/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSON, CreateOrganizationPaymentBillingInfoSetupIntentResponseDataToJSON } from './CreateOrganizationPaymentBillingInfoSetupIntentResponseData';
export function CreateOrganizationPaymentBillingInfoSetupIntentResponseFromJSON(json) {
    return CreateOrganizationPaymentBillingInfoSetupIntentResponseFromJSONTyped(json, false);
}
export function CreateOrganizationPaymentBillingInfoSetupIntentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSON(json['data'])
    };
}
export function CreateOrganizationPaymentBillingInfoSetupIntentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: CreateOrganizationPaymentBillingInfoSetupIntentResponseDataToJSON(value.data)
    };
}
